import React, { useCallback, useEffect, useState } from "react";
import "../styles/History.css";
import { graphqlRequest } from "../../../utils/graphqlRequest";
import {
  useProfileBookingId,
  useProfileRefresh,
} from "../ProfileBookingContext";
import { formatBookingHistoryItem } from "../utils/formatBookingHistory";

const FIND_BOOKING_HISTORY = `
  query FindBookingHistory($bookingId: String!) {
    findBookingHistory(bookingId: $bookingId) {
        id
        entityType
        entityId
        title
        description
        metadata
        createdBy
        bookingId
        createdAt
    }
  }
`;

export default function History() {
  const [activities, setActivities] = useState([]);
  const bookingId = useProfileBookingId();
  const { refreshToken } = useProfileRefresh();

  const fetchBookingHistory = useCallback(async (id) => {
    try {
      const data = await graphqlRequest(FIND_BOOKING_HISTORY, { bookingId: id });
      const result = data?.findBookingHistory || [];

      const formatted = result.map((item) => {
        const dateObj = new Date(item.createdAt);
        const date = dateObj.toLocaleDateString("en-AU", {
          day: "numeric",
          month: "long",
        });
        const time = dateObj.toLocaleTimeString("en-AU", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        const { activity, category } = formatBookingHistoryItem(item);

        return {
          id: item.id,
          date,
          time,
          activity,
          category,
          entityType: item.entityType,
        };
      });

      setActivities(formatted);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  }, []);

  useEffect(() => {
    if (bookingId) {
      fetchBookingHistory(bookingId);
    }
  }, [bookingId, refreshToken, fetchBookingHistory]);

  const grouped = activities.reduce((acc, item) => {
    if (!acc[item.date]) acc[item.date] = [];
    acc[item.date].push(item);
    return acc;
  }, {});

  return (
    <div className="history-container">
      {Object.keys(grouped).length === 0 && (
        <p className="history-empty">No activity recorded for this deal yet.</p>
      )}

      {Object.keys(grouped).map((date) => (
        <div key={date} className="history-group">
          <h3 className="history-date">{date}</h3>

          <div className="timeline">
            {grouped[date].map((item, idx) => (
              <div key={item.id || `${date}-${idx}`} className="timeline-item">
                <div className="timeline-time">{item.time}</div>

                <div className="timeline-line-wrapper">
                  <div className="timeline-dot" />
                  {idx !== grouped[date].length - 1 && (
                    <div className="timeline-line" />
                  )}
                </div>

                <div className="timeline-card">
                  {item.category ? (
                    <span className="timeline-category">{item.category}</span>
                  ) : null}
                  <p className="timeline-activity">{item.activity}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
